import React from 'react';

import {
  DataGrid,
  PAGE_SIZE_OPTIONS,
  SearchInput,
} from '@dutchie/backoffice-ui-library';
import { GridEventListener } from '@mui/x-data-grid';
import { useNavigate } from 'react-router-dom';

import { ROUTES } from 'src/apps/brand-connect/routes';

import { BRAND_DETAIL_GROUP_ID, BRAND_DETAIL_TAB_LABELS } from '../detail';
import { ROW_HEIGHT, SCROLLBAR_SIZE } from '../shared/constants';
import { useServerPaginatedBrandData } from '../shared/hooks/use-server-paginated-brand-data';
import {
  DataGridContainer,
  GridAndSearchContainer,
  Heading,
  Page,
  SearchContainer,
} from '../shared/styled';

import { useColumns } from './use-columns';

export const Brands = () => {
  const {
    handleSearchChange,
    loading,
    paginationModel,
    rows,
    setPaginationModel,
    setSortModel,
    sortModel,
    totalCount,
  } = useServerPaginatedBrandData();

  const navigate = useNavigate();

  const columns = useColumns();

  const handleRowClick: GridEventListener<'rowClick'> = (params) => {
    navigate(
      `${ROUTES.BRANDS}/${params.row.id}?activeTab-${BRAND_DETAIL_GROUP_ID}=${BRAND_DETAIL_TAB_LABELS.brandCatalog}`,
    );
  };

  return (
    <Page>
      <Heading subheader="This list contains all brands in the Dutchie Brand Network with sales in your state.">
        Brands
      </Heading>
      <GridAndSearchContainer>
        <SearchContainer>
          <SearchInput
            onSearchChange={handleSearchChange}
            placeholder="Search brands by name..."
          />
        </SearchContainer>
        <DataGridContainer>
          <DataGrid
            columns={columns}
            loading={loading}
            onPaginationModelChange={setPaginationModel}
            onRowClick={handleRowClick}
            onSortModelChange={setSortModel}
            paddedFooter
            pageSizeOptions={PAGE_SIZE_OPTIONS}
            paginationMode="server"
            paginationModel={paginationModel}
            rowCount={totalCount}
            rowHeight={ROW_HEIGHT}
            rows={rows}
            scrollbarSize={SCROLLBAR_SIZE}
            sortingMode="server"
            sortModel={sortModel}
          />
        </DataGridContainer>
      </GridAndSearchContainer>
    </Page>
  );
};
